import { Headline, Text } from 'forly-kit';
import React, { useEffect, useState } from 'react';
import styles from './resetPassPage.module.scss';
import { SubmitHandler } from 'react-hook-form';
import { ResetPassForm } from 'src/components/Forms/ResetPassForm/ResetPassForm';
import { IResetPassFormData } from 'src/components/Forms/ResetPassForm/resetPassForm.types';
import { ErrorModal } from 'src/components/modals/ErrorModal/ErrorModal';
import { PasportLayout } from 'src/components/PasportLayout/PasportLayout';
import { IResetPassData } from 'types/common.types';
import { registrationApi } from './../../services/registerService';
import { colors } from 'forly-kit/dist/colors';
import { useTranslation } from 'react-i18next';

const Page: React.FC = () => {
	const {t} = useTranslation();
	const [resetError, setResetError] = useState<string>('');
	const [successResetPass, setSuccessReset] = useState<boolean>(false);
	const [
		resetPass,
		{isLoading: resetPassPending, isSuccess: resetPassSuccess, error: resetPassError}
	] = registrationApi.useResetPassMutation();

	useEffect(() => {
		if (resetPassError) {
			setResetError(t('errors.unknownError'));
		}
	}, [resetPassError]);

	useEffect(() => {
		if (resetPassSuccess) {
			setSuccessReset(true);
		}
	}, [resetPassSuccess]);

	const closeErrorModal = () => {
		setResetError('');
	};

	const onSubmit: SubmitHandler<IResetPassFormData> = async (data) => {
		if (!data.email) {
			return;
		}

		const resetPassData: IResetPassData = {
			email: data.email
		};
		
		resetPass(resetPassData);
	};

	return <>
		<PasportLayout>
			{successResetPass
				? <>
					<Headline 
						className={styles.title} 
						type='h0' 
						color={colors.primary800}
					>
						{t('resetPassTitle')}
					</Headline>
					<Text size='m'>{t('resetPassSubtitle')}</Text>
				</>
				: <ResetPassForm 
					action={onSubmit}
					isPending={resetPassPending}
				/>}
			
		</PasportLayout>
		<ErrorModal 
			isOpen={!!resetError}
			onClose={closeErrorModal}
			error={resetError}
		/>
	</>;
};

export const ResetPassPage = React.memo(Page);